import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedFacilityApi } from '../api/shared-facility-api';
import { OdataQueryOptions } from '../models/odata/odata-query-options';
import { Facility } from '../models/facility/facility';
import { FacilityContact } from '../models/facility/facility-contact';
import { ODataResponse } from '../models/odata/odata-response';

@Injectable({
  providedIn: 'root',
})
export class SharedFacilityRepository {
  private facilityApi = inject(SharedFacilityApi);

  getFacilities(odataQueryOptions: OdataQueryOptions): Observable<ODataResponse<Facility>> {
    return this.facilityApi.getFacilities(odataQueryOptions);
  }

  findFacilities(odataQueryOptions: OdataQueryOptions): Observable<ODataResponse<Facility>> {
    return this.facilityApi.findFacilities(odataQueryOptions);
  }

  getFacility(facilityId: number, odataQueryOptions: OdataQueryOptions | null = null): Observable<Facility> {
    return this.facilityApi.getFacility(facilityId, odataQueryOptions);
  }

  createFacility(facility: Facility) {
    return this.facilityApi.createFacility(facility);
  }

  getFacilityContacts(facilityId: number, odataQueryOptions: OdataQueryOptions): Observable<FacilityContact[]> {
    return this.facilityApi.getFacilityContacts(facilityId, odataQueryOptions).pipe(map(o => o.value));
  }

  createFacilityContact(facilityContact: FacilityContact): Observable<FacilityContact> {
    return this.facilityApi.createFacilityContact(facilityContact);
  }
}
